var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fullscreen-gallery blueimp-gallery",class:{
    'blueimp-gallery-controls': _vm.displayControls,
  }},[_c('div',{staticClass:"slides"}),_c('div',{staticClass:"title"}),_c('a',{staticClass:"prev"}),_c('a',{staticClass:"next"}),_c('a',{staticClass:"close"}),_c('ol',{staticClass:"indicator"})])}
var staticRenderFns = []

export { render, staticRenderFns }